import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=a09202f4&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style1 from "./edit.vue?vue&type=style&index=1&id=a09202f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09202f4",
  null
  
)

export default component.exports